import { StepProps } from '../../types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import TicketHolder from '../TicketHolder';
import * as toast from 'legacy/common/utils/toast';
import { useRollbackTicketCommand } from '../../../../hooks';

const ConfirmRevokeStep = ({ ticket, onClose, refetchTickets }: StepProps) => {
  const { mutate: revokeTicketCommand } = useRollbackTicketCommand();

  const onRevoke = () => {
    revokeTicketCommand(
      {
        ticketId: ticket.id
      },
      {
        onSuccess: () => {
          refetchTickets();
          onClose();
          toast.success('Ticket successfully revoked');
        },
        onError: (error) => {
          toast.error(error.message);
        }
      }
    );
  };

  return (
    <>
      <div className="p-4 flex flex-col gap-4">
        <p className="font-normal text-base">
          This ticket will go back to your Bounce Wallet. You will be able to
          transfer it again once revoked.
        </p>
        <TicketHolder ticket={ticket} isTransfer isTicketOwner />
      </div>
      <div className="border-t-1 border-solid border-gray-200 p-4">
        <Button onClick={onRevoke} type={ButtonType.Danger}>
          Revoke
        </Button>
      </div>
    </>
  );
};

export default ConfirmRevokeStep;
